// Copyright (c) 2022 by Move Closer

import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'

import { IRelatedService, PickerCallback } from '../../../../contexts'

import { AddonData } from '../../Hero.contracts'

/**
 * Abstract hero addon that every hero addon ** SHOULD ** extend.
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Component
export class AbstractHeroAddon extends Vue {
  /**
   * `ModuleContent` of the selected addon's form.
   */
  @PropSync('model', { type: Object, required: true })
  public _model!: AddonData['content']

  /**
   * Callback used by form to pick relate.
   */
  @Prop({ type: Function, required: false })
  public readonly pickRelated!: PickerCallback

  /**
   * Service capable of resolving the actual data of the related objects.
   */
  @Prop({ type: Object, required: true })
  public readonly relatedService!: IRelatedService
}
